import {Grid} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {noop} from '@logistics-frontend/utils'
import clsx from 'clsx'
import React, {memo} from 'react'

import {classes} from './styles'
import {PromoBaseProps} from './types'

const YangoPromo: React.FC<PromoBaseProps> = props => {
  const t = useI18n()
  const {
    title = t('route_install_yango'),
    text = t('route_promo_text'),
    link = 'https://apps.apple.com/app/id1437157286',
    fullWidth = false,
    onClick = noop,
  } = props

  return (
    <a className={clsx(classes.container, classes.containerYango)} href={link} onClick={onClick}>
      <Grid justify="space-around" container>
        <Grid className={fullWidth && classes.adaptiveGrid} xs={9} item>
          <div className={classes.title}>{title}</div>
          <div className={classes.text}>{text}</div>
        </Grid>
        <Grid item>
          <div className={clsx(classes.icon, classes.iconYango, fullWidth && classes.fullWidthIcon)} />
        </Grid>
      </Grid>
    </a>
  )
}

export default memo(YangoPromo)
